import { Skeleton } from 'antd';
import * as Styled from './styles';

const PROPERTIES_MOCK = Array.from({ length: 5 }, (v, i) => i);
export const NftPropertiesSkeleton = () => {
  return (
    <Styled.NftPropertiesWrapper>
      {PROPERTIES_MOCK.map(property => (
        <Styled.NftProperty key={property}>
          <Styled.NftPropertyNameWrapper>
            <Styled.NftPropertyTitle>
              <Skeleton.Button
                active
                style={{ width: '50px', height: 18, margin: 0 }}
                shape="round"
              />
            </Styled.NftPropertyTitle>
            <Styled.NftPropertyName>
              <Skeleton.Button
                active
                style={{ width: '100px', height: 24, margin: 0 }}
                shape="round"
              />
            </Styled.NftPropertyName>
          </Styled.NftPropertyNameWrapper>
          <Styled.NftPropertyRarity>
            <Skeleton.Button
              active
              style={{ width: '50px', height: 20, margin: 0 }}
              shape="round"
            />
          </Styled.NftPropertyRarity>
        </Styled.NftProperty>
      ))}
    </Styled.NftPropertiesWrapper>
  );
};
